import { AiseaApiFactory } from "@/api/aisea/apiFactory";

import FireStoreService from "@/services/fireStoreService";
import LocalDbService from "@/services/localDbService";

import ChannelDataUtil from "@/utils/ChannelDataUtil";
import moment from "moment";
import Vue from "vue";

const epVesselSecureDataflowChannel = AiseaApiFactory.get("enterpriseVesselSecureDataflowChannel");
const epVesselApi = AiseaApiFactory.get("enterpriseVessel");
const epVesselDisplayChannelApi = AiseaApiFactory.get("enterpriseVesselDisplayChannel");

const evhApi = AiseaApiFactory.get("enterpriseVoyageHistories");


export default {

  /**
   * 
   */
   async fetchVoyageHistories(_, payload) {
    let res = await evhApi.fetch(payload);
    return res.data.summaries;
  },

  /**
   * 
   */
   appendVoyageHistoryToEngineInfo({ commit }, payload) {
    commit("APPEND_VOYAGE_HISTORY_TO_ENGINE_INFO", payload);
  },

  /**
   * 
   */
  async initializeEngineInfo({ commit }, enterpriseVesselId) {
    const engineInfo = {};

    let payload = {
      is_disabled: false,
      is_deleted: false,
      page: 0,
      limit: 200
    };
    let res0 = await epVesselApi.search(payload);
    const vesselInfo = res0.data.vessels.find(vessel => vessel.enterprise_vessel_id === enterpriseVesselId);

    if (vesselInfo) {
      engineInfo['vessel_info'] = vesselInfo;

      const res1 = await epVesselDisplayChannelApi.getChannelOrigins(vesselInfo.enterprise_vessel_id);
      for( let channelOriginObj of res1.data.channel_origins ) {
        const resVersionInfo = await epVesselSecureDataflowChannel.getChannelVersions(vesselInfo.id, { origin: channelOriginObj.origin_number, kind: channelOriginObj.kind });  // このAPIに対しては origin_numberとvessel_id  を指定
        if ( !engineInfo['version'] ) {
          engineInfo['version'] = {};
        }
        engineInfo['version'][channelOriginObj.kind] = resVersionInfo.data;
      }
    }

    commit("SET_ENGINE_INFO", engineInfo);
  },


  /**
   * 
   */
   async initializeChannelMaster({state, getters, dispatch, commit}) {

    const vesselInfo = state.engineInfo['vessel_info'];

    let channelOriginsMap = {};
    let channelGroupsMapByOrigin = {};

    const res1 = await epVesselDisplayChannelApi.getChannelOrigins(vesselInfo.enterprise_vessel_id);
    for(let channelOriginObj of res1.data.channel_origins) {
      channelOriginsMap[channelOriginObj.id] = channelOriginObj;
      channelGroupsMapByOrigin[channelOriginObj.origin_number] = {};
      const res2 = await epVesselDisplayChannelApi.getChannelGroups(vesselInfo.enterprise_vessel_id, channelOriginObj.id); 
    
      let promiseAll = [];

      for(let channelGroupObj of res2.data.channel_groups) {

        promiseAll.push(new Promise(( resolve ) => { 
          epVesselDisplayChannelApi.getChannels(vesselInfo.enterprise_vessel_id, channelOriginObj.id, channelGroupObj.channel_group_id, { version_id: state.engineInfo.version[channelOriginObj.kind].version_id}).then((res3) => {
            channelGroupsMapByOrigin[channelOriginObj.origin_number][channelGroupObj.channel_group_id] = {
              channelOrigin: channelOriginObj,
              channelGroup: channelGroupObj,
              channels: res3.data.channels,
            };
            resolve(channelGroupObj.channel_group_id);
          })
        }));

      }
      await Promise.all(promiseAll);
    }

    commit("SET_CHANNEL_ORIGINS_MAP", channelOriginsMap);
    commit("SET_CHANNEL_GROUPS_MAP_BY_ORIGIN", channelGroupsMapByOrigin);

    // firestoreに選択していたoriginを取得
    const engineDataSetting = await FireStoreService.getEngineDataSetting(vesselInfo.id);
    if (engineDataSetting.selected_channel_origin_id === "custom") {
      return dispatch(
        "setSelectedChannelOriginId",
        engineDataSetting.selected_channel_origin_id,
      );
    }
    if (
      // NOTE:storeのselected_channel_origin_idは(string("custom") || number)だが、firestoreには一度stringで保存されると以降stringとなるためparseしている
      getters.getChannelOriginList
        .map(origin => origin.origin_number)
        .includes(Number(engineDataSetting.selected_channel_origin_id))
    ) {
      return dispatch(
        "setSelectedChannelOriginId",
        Number(engineDataSetting.selected_channel_origin_id),
      );
    }
    if ( getters.getChannelOriginList.length > 0 ) {
      dispatch("setSelectedChannelOriginId", getters.getChannelOriginList[0].origin_number);
    }
  },


  /**
   * チャンネルデータのキャッシュクリア.
   */
  async clearLocalDbChannelData() {
    await LocalDbService.clearChannelData();
  },

  /**
   * LiveモードとDateモード変更時の処理.
   */
  async setModeState({ commit, dispatch }, data) {
    if (data !== "live") {
      dispatch("unsubscribeFirestoreForChart");      
    }
    commit("SET_MODE", data);
  },

  async initializeCustomChannelIds({ state, commit }) {
    // 船舶単位でカスタムチャンネルを取得
    const vesselInfo = state.engineInfo['vessel_info'];
    const engineDataSetting = await FireStoreService.getEngineDataSetting(vesselInfo.id);
    const ids = engineDataSetting.custom_reports_channel_ids || [];
    commit("SET_CUSTOM_CHANNEL_IDS", ids);
    return ids;
  },

  async setSelectedChannelGroupId({ commit }, data) {
    commit("SET_SELECTED_CHANNEL_GROUP_ID", data);
  },

  










  async setChannelTimeFromState({ commit }, data) {
    commit("SET_CHANNEL_TIME_FROM", data)
  },
  async setChannelTimeToState({ commit }, data) {
    commit("SET_CHANNEL_TIME_TO", data)
  },



    /**
     *  データを取得し、this.all_channel_dataに埋め込むメソッド.
     */
     async getChannelDetailData({ state, getters, dispatch}) {

      const engineInfo = state.engineInfo;
      let channels = [];
      if ( state.selectedChannelOriginId === 'custom' ) {

        let customChannelIds = ( getters.getCustomChannelIds && getters.getCustomChannelIds.length > 0 )
          ? getters.getCustomChannelIds
          // NOTE: 空だったら、firestoreからカスタムチャンネルを取得して反映している
          : await dispatch("initializeCustomChannelIds");

        customChannelIds.forEach(customChannelId => {
          Object.values(state.channelGroupsMapByOrigin).forEach( channelGroups => {
            Object.values(channelGroups).forEach(channelGroup => {
              channelGroup.channels
                .filter(channel => channel.channel_id === customChannelId)
                .forEach(channel => {
                  let customChannel = JSON.parse(JSON.stringify( channel ));
                  customChannel.origin_id  = channelGroup.channelOrigin.id;
                  customChannel.kind       = channelGroup.channelOrigin.kind;
                  customChannel.version_id = engineInfo['version'][channelGroup.channelOrigin.kind].version_id;
                  channels.push(customChannel);
                });
            });
          });
        });


      } else {

        channels = state.channelGroupsMapByOrigin[state.selectedChannelOriginId][getters.getSelectedChannelGroupId].channels
                  .map(channel => {
                    let extendedChannel = JSON.parse(JSON.stringify( channel ));
                        extendedChannel.origin_id  = state.selectedChannelOriginId;
                        extendedChannel.kind       = state.channelGroupsMapByOrigin[state.selectedChannelOriginId][getters.getSelectedChannelGroupId].channelOrigin.kind;
                        extendedChannel.version_id = engineInfo['version'][extendedChannel.kind].version_id;
                    return extendedChannel;
                  })
      }

      let payload = {
        vessel_id: engineInfo.vessel_info.id,
        channels: channels,
        display_type: (state.selectedChannelOriginId === 'custom' ) ? 'custom' : 'normal',
      };
      return await dispatch("getChannelsDetailDataList", payload);

    },





  /**
   * チャンネル一覧を取得.
   * 
   * localDBのキャッシュも考慮。API取得は searchChannelsDataFromApi() に依頼。
   */
  async getChannelsDetailDataList({ state }, payload) {

    let params = {};
    params.channelTimeFrom = payload.channelTimeFrom ? payload.channelTimeFrom : state.channelTimeFrom;
    params.channelTimeTo = payload.channelTimeTo ? payload.channelTimeTo : state.channelTimeTo;
    params.vesselId = payload.vessel_id;


    // 既に保存してある customChannelIds か channelGroupData を使って、 channelInfoを作成
    // channelInfoが確定するとHighChartsPointList(拡張)が作れるので、コンバートしてセット

    let channelsDataList = new Array();

    for ( let channel of payload.channels  ) {

      params.originId  = channel.origin_id;
      params.kind      = channel.kind;
      params.versionId = channel.version_id;
  
      let obj = {
        channel_id: channel.channel_id,
        channel_id_escaped: channel.channel_id.toLowerCase().replace(":", "_"),
        channel_name: channel.channel_name,
        display_unit: channel.unit,
        kind: channel.kind,
        hasError: false,
        data: [],
        pointDataListQueryParams: params,
        value_number_range: channel.value_number_range,
        value_string_options: channel.value_string_options,
      }
      channelsDataList.push(obj)
    }

    return channelsDataList;
  },


  /**
   *  複数のchannel_idを指定して座標データ群を取得。出力はHighChartsにセット可能なデータ群。API通信は１回目だけ、２回目からはキャッシュを使う.
   * 
   */
   async convertChannelDataListForChart({ state, dispatch }, payload) {

    let channelIdsFromApi = [];

    // チャンネルデータ+座標データfromキャッシュのリストを作成して軸を固める。
    const cacheStartTime = moment().valueOf();
    const promiseChannelDataInfoList = payload.channelDataBlock.map( channelData => {
      return new Promise((resolve) => {

        let cachePointDataList = [];
        LocalDbService.getChannelData(channelData.channel_id).then((channelDataFromCache) => {
          if ( channelDataFromCache && channelDataFromCache.point_data) {
            const channelTimeFromValueOf = moment.utc(state.channelTimeFrom).valueOf();
            const channelTimeToValueOf   = ( payload.mode === "live" ) ? moment().valueOf() : moment.utc(state.channelTimeTo).valueOf();
            cachePointDataList = channelDataFromCache.point_data
                              .filter(pointData => ( moment( pointData.channel_time || pointData.timestamp ).valueOf() >= channelTimeFromValueOf
                                                  && moment( pointData.channel_time || pointData.timestamp ).valueOf() <= channelTimeToValueOf));
          }
      
          if ( cachePointDataList.length < 60 ) {
            // キャッシュが利用できなかったchannel_idは記憶しておく。
            channelIdsFromApi.push(channelData.channel_id);
          }
  
          resolve({
                    channelId:     channelData.channel_id, 
                    channelData:   channelData,
                    pointDataList: cachePointDataList,
                  }); 
        });
      });  
    });
    let channelDataInfoList = await Promise.all(promiseChannelDataInfoList);
    if ( (moment().valueOf() - cacheStartTime) > 3000 ) {
      Vue.$log.debug("measure from Cache convertChannelDataListForChart channel_ids = ", payload.channelDataBlock.map(x => x.channel_id), ', time = ', moment().valueOf() - cacheStartTime, 'ms ', moment(cacheStartTime).format('HH:mm:ss') );
    }


    // キャッシュ利用できなかったチャンネルはAPIで一括取得
    let pointDataListMapFromApi = {};
    if ( channelIdsFromApi.length > 0 ) {
      const apiStartTime = moment().valueOf();

      const params = payload.channelDataBlock[0].pointDataListQueryParams;
      const channelTimeTo = ( payload.mode === "live" ) ? moment().toISOString() : params.channelTimeTo;
      const payloadForSearchChannels = {
        vessel_id: params.vesselId,
        params: {
          origin:            params.originId,
          kind:              params.kind,
          version_id:        params.versionId,
          channel_time_from: params.channelTimeFrom,
          channel_time_to:   channelTimeTo,
          channel_ids:       channelIdsFromApi,
        }
      };
      const resData = await dispatch("searchChannelsDataFromApi", payloadForSearchChannels); // API通信実行.
      resData.data.forEach( channelData => {
        pointDataListMapFromApi[channelData.channel_id] = channelData.channel_data;
      });

      if ( (moment().valueOf() - apiStartTime) > 3000 ) {
        Vue.$log.debug("measure from API   convertChannelDataListForChart channel_ids = ", channelIdsFromApi, ', time = ', moment().valueOf() - apiStartTime, 'ms ', params.channelTimeFrom, params.channelTimeTo, moment(apiStartTime).format('HH:mm:ss') );
      }
    }

  
    // チャンネルデータ +（ 座標データ群fromキャッシュ or 座標データ群fromAPI ) を HighCharts用に加工 
    const promisePointDataInfoList = channelDataInfoList.map( channelDataInfo => {
      return new Promise((resolve) => {

        // ポイント座標データ群を API取得結果とキャッシュのどちらから取得するかを決定.
        const pointDataList = pointDataListMapFromApi[channelDataInfo.channelId] 
                                ? pointDataListMapFromApi[channelDataInfo.channelId] 
                                : channelDataInfo.pointDataList;

        // ポイント座標データ群をチャート表示用に変換
        dispatch( "convertPointDataList", {
          channel_id:           channelDataInfo.channelData.channel_id,
          value_number_range:   channelDataInfo.channelData.value_number_range,
          value_string_options: channelDataInfo.channelData.value_string_options,
          pointDataList: pointDataList,
        }).then((convertedPointDataList) => {
                  // HighChartsに渡す前にポイント座標データの重複を除去.
          let distinctConvertedPointDataList = [];
          let prevConvertedPointDataX = 0;
          for(let convertedPointData of convertedPointDataList ){
            if ( prevConvertedPointDataX < convertedPointData.x ) {
              distinctConvertedPointDataList.push(convertedPointData);
            }
            prevConvertedPointDataX = convertedPointData.x;
          }

          resolve({
            channelId:              channelDataInfo.channelId,
            channelData:            channelDataInfo.channelData,
            convertedPointDataList: distinctConvertedPointDataList,
          });
        });
      });
    });

    return await Promise.all(promisePointDataInfoList);
  },


  /** 
   * 座標データ群をHighChart用に変換する。
   * 
   * channel_id           (from Master)
   * value_number_range   (from Master)
   * value_string_options (from Master)
   * pointDataList        (from ChannelDataDetail )
   * 
   */
  async convertPointDataList(_nouse, payload) {
    let pointDataList = payload.pointDataList;
    let value_number_range = payload.value_number_range;
    let stringOptions = payload.value_string_options ? payload.value_string_options.split("/") : [];

    let promiseAll = ! pointDataList ? [] : pointDataList.map(pointData => {
      return new Promise((resolve) => {

        let pointDataForHighCharts = {};
        if ( Object.keys(pointData).includes('vn') ) {
          // firestoreから来た場合
          const { timestamp, vn, vs, status } = pointData;
          let errorFlg = ChannelDataUtil.isAbnormalMachinery(status);
            pointDataForHighCharts = {
              x: timestamp,
              y: vn,
              y_string: vs,
              status: status,
              error: errorFlg,
              colorIndex: 10,
          };
        } else {
          // APIからの取得結果で、チャートのpointDataに使えそうなものは以下。
          const { channel_time, value_number, value_string, status } = pointData;
          let errorFlg = ChannelDataUtil.isAbnormalMachinery(status);

          pointDataForHighCharts = {
              x: moment(channel_time).valueOf(),
              y: value_number,
              y_string: value_string,
              status: status,
              error: errorFlg,
              colorIndex: 10,
          };
        }


        if (value_number_range) { // 数値データかイベントデータかの判断
          // normal
          pointDataForHighCharts.color = "#2D9CDB";
          pointDataForHighCharts.marker = {
            radius: 1,
            states: {
              hover: {
                radius: 3,
                fillColor: pointDataForHighCharts.error
                  ? "#EB5757"
                  : "#2D9CDB",
                lineColor: "white",
                lineWidth: 0,
              },
            },
          };
        } else {
          // gantt
          const ganntPointIndex = stringOptions.findIndex(
            option => option === pointDataForHighCharts.y_string,
          );
          if (ganntPointIndex >= 0) {
            pointDataForHighCharts.y = ganntPointIndex;
            pointDataForHighCharts.color = "#2D9CDB";
            pointDataForHighCharts.marker = {
              radius: 1,
              states: {
                hover: {
                  radius: 3,
                  fillColor: pointDataForHighCharts.error
                    ? "#eb5757"
                    : "#2d9cdb",
                  lineWidth: 0,
                },
              },
            };
          } else {
            // y_stringが無効値の場合は、そのポイントデータはスキップ。
            pointDataForHighCharts = null; 
          }
        }

        resolve(pointDataForHighCharts);
      });
    });

    const expandPointDataList = await Promise.all(promiseAll);
    return expandPointDataList.filter(pointData => pointData != null);
  },


  /**
   * チャート座標情報をAPIから取得.
   * 
   */
  async searchChannelsDataFromApi(_, payload) {
    
    let res = await epVesselSecureDataflowChannel.searchChannelsData(payload.vessel_id, payload.params);
    let promiseJob = [];
    res.data.data.forEach(e => {
        let job = new Promise((resolve) => {
          resolve(LocalDbService.saveChannelData(e.channel_id, e.channel_data));
        })
        promiseJob.push(job);
      }
    )
    
    return res.data
  },












  /**
   *  カスタムレポートの追加チャンネルを検索
   */
  async searchChannels(_nouse, payload) {
    let res = await epVesselSecureDataflowChannel.searchChannels(payload.vessel_id, payload.params);
    let resultChannels = [];
    res.data.channels.forEach(channel => {
      let obj = {
        id: channel.channel_id,
        name: channel.channel_name,
        name_ja: channel.channel_name,
        unit: channel.unit,
        id_name: channel.channel_id + channel.channel_name,
      };
      resultChannels.push(obj);
    })
    let searchResult = {
      channels: {
        key: "id_name",
        data: resultChannels
      }
    };
    return searchResult;
  },


  async setCustomChannelIdsState({state, commit }, ids) {
    // 船舶単位でカスタムチャンネルを保存
    const vesselInfo = state.engineInfo['vessel_info'];
    await FireStoreService.setEngineDataSetting(vesselInfo.id, "custom_reports_channel_ids", ids);
    commit("SET_CUSTOM_CHANNEL_IDS", ids);
  },

  async setChannelGroupFocusPoint({ commit }, data) {
    commit("SET_CHANNEL_GROUP_FOCUS_POINT_MAP", data);
  },

  async setReferencedChannelIdMap({ commit }, data) {
    commit("SET_REFERENCED_CHANNEL_ID_MAP", data);
  },

  async setSelectedChannelOriginId({ state, getters, commit }, channelOriginId) {
    // 船舶単位で選択しているoriginを保存
    const vesselInfo = state.engineInfo['vessel_info'];
    await FireStoreService.setEngineDataSetting(vesselInfo.id, "selected_channel_origin_id", String(channelOriginId));
    commit("SET_SELECTED_CHANNEL_ORIGIN_ID", channelOriginId);

    if ( channelOriginId === 'custom' ) {
      commit("SET_SELECTED_CHANNEL_GROUP_ID", "custom");
    } else {
      let channelGroupList = getters.getChannelGroupListByOrigin(channelOriginId);
      const group = channelGroupList.find(x => x.channelGroup.channel_group_id === getters.getSelectedChannelGroupId );
      const channelGroupId = group ? group.channelGroup.channel_group_id : channelGroupList.length > 0 ? channelGroupList[0].channel_group_id : null;
      commit("SET_SELECTED_CHANNEL_GROUP_ID", channelGroupId);
    }
  },


  /**
   * FireStoreの監視追加(チャート専用).
   */
  async pushUnsubscribeForChart({ commit }, data) {
    commit("PUSH_UNSUBSCRIBE_FOR_CHART", data);
  },

  /**
   * FireStoreの監視解除(チャート専用).
   */
  async unsubscribeFirestoreForChart({ commit }) {
    await commit("UNSUBSCRIBE_FIRE_STORE_FOR_CHART");
  },


}